var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUnionIcon = function SvgUnionIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.864 0V1.94266H6.48788V0H7.54694V1.94266H9.17082V0H10.2299V1.94266H12.2047V3.77835H14.124V4.83741H12.2043V6.46129H14.1237V7.52035H12.2043V9.14423H14.1237V10.2033H12.2043V12.0566H10.2295V14H9.17047V12.0566H7.54659V14H6.48753V12.0566H4.86365V14H3.80459V12.0566H2.09069V10.2033H0.124023V9.14423H2.09069V7.52035H0.124023V6.46129H2.09069V4.83741H0.124023V3.77835H2.09069V1.94266H3.80494V0H4.864ZM11.1456 3.00171H3.14974V10.9976H11.1456V3.00171ZM9.52172 4.6256V9.3737H4.77363V4.6256H9.52172ZM8.46267 5.68465H5.83268V8.31464H8.46267V5.68465Z",
    fill: "#031FEF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnionIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/unionIcon.bf0b41c1.svg";
export { ForwardRef as ReactComponent };